import { render, staticRenderFns } from "./newProjectDialog.vue?vue&type=template&id=40368af2&"
import script from "./newProjectDialog.vue?vue&type=script&lang=js&"
export * from "./newProjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports